import {axiosBaseQuery} from './axiosBaseQuery';
import {createApi} from '@reduxjs/toolkit/query/react';

export const apiService = createApi({
    reducerPath: 'api',
    baseQuery: axiosBaseQuery(),
    keepUnusedDataFor: 0,
    endpoints: builder => ({})
});